export default __webpack_public_path__ + "static/media/STG_Piping.1695ec1a.jpg";